import { AmenitiesType } from '@utils/types/amenities';
import { ReactNode } from 'react';
import Cable from './cable';
import EspressoMachine from './espresso-machine';
import Grill from './grill';
import GroupSpace from './group-space';
import HairDryer from './hair-dryer';
import HeatingAndAC from './heating-and-ac';
import HeightChair from './height-chair';
import HotTub from './hot-tub';
import Iron from './iron';
import Keyboard from './keyboard';
import Laundry from './laundry';
import LoremCookware from './lorem-cookware';
import MalinGoetzSoap from './malin-goetz-soap';
import Monitor from './monitor';
import Mouse from './mouse';
import ParachuteLinens from './parachute-linens';
import Patio from './patio';
import Peloton from './peloton';
import Pool from './pool';
import ProfessionalCleaning from './professional-cleaning';
import SmartTv from './smart-tv';
import SonosSpeakers from './sonos-speakers';
import StandingDesk from './standing-desk';
import Tableware from './tableware';
import Whiteboard from './whiteboard';
import Wifi from './wifi';

export const icons: Record<AmenitiesType, ReactNode> = {
  parachute_linens: <ParachuteLinens />,
  linens: <ParachuteLinens />,
  lorem_cookware: <LoremCookware />,
  cookware: <LoremCookware />,
  cable: <Cable />,
  espresso_machine: <EspressoMachine />,
  hair_dryer: <HairDryer />,
  hot_tub: <HotTub />,
  height_chair: <HeightChair />,
  keyboard: <Keyboard />,
  laundry: <Laundry />,
  'malin+goetz_soap': <MalinGoetzSoap />,
  monitor: <Monitor />,
  patio: <Patio />,
  grill: <Grill />,
  smart_tv: <SmartTv />,
  tv: <SmartTv />,
  professional_cleaning: <ProfessionalCleaning />,
  sonos_speakers: <SonosSpeakers />,
  pool: <Pool />,
  tableware: <Tableware />,
  wifi: <Wifi />,
  standing_desk: <StandingDesk />,
  group_space: <GroupSpace />,
  mouse: <Mouse />,
  whiteboard: <Whiteboard />,
  peloton: <Peloton />,
  iron: <Iron />,
  air_conditioning: <HeatingAndAC />,
  heating: <HeatingAndAC />,
};
